import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';

const Callback = () => {
  const { authStore } = useRootStore();
  const history = useHistory();
  const { hash } = useLocation();
  useEffect(() => {
    if (/access_token|id_token|error/.test(hash)) {
      authStore.handleAuthentication(history);
    }
  }, []);

  return <Spinner />;
};

export default Callback;
